import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useEffect, useState } from "react";
import { BrowserView, isBrowser, MobileView } from "react-device-detect";
import ReactGA from "react-ga4";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import users from "../../assets/images/icon_profile/user.svg";
import Config from "../../config/Config";
import { setLoading } from "../../core/feature/config/configSlice";
import {
  comboStudentsClassViolation,
  violationPointDashboard,
} from "../../core/service/api_violation_point";
import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker";
import ViolationPointMobile from "./violationPointMobile";
import ViolationPointWeb from "./violationPointWeb";
import { setToken } from "../../core/feature/token/tokenSlice";
import { i18n } from "../../translations/i18n";
import { setLanguage } from "../../core/feature/language/languageSlice";
import * as API from "../../core/service/api";
import { setUser } from "../../core/feature/user/userSlice";

const ViolationPointComponent = () => {
  const gaEventTracker = useAnalyticsEventTracker("ViolationPoint");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [isScanOpen, setIsScanOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isScan, setIsScan] = useState(false);
  const [students, setStudents] = useState<any>([]);
  const [isToken, setIsToken] = useState<any>(false);
  const { t } = useTranslation();
  const [data, setData] = useState<any>({});
  const [studentSelected, setStudentSelected] = useState<any>({});
  const env = Config.BaseUrlDev;
  const [callerIdentity, setCallerIdentity] = useState<any>();
  const [caller, setCaller] = useState<any>();

  const closeModal = () => {
    setIsOpen(false);
    navigate(`/home`, { replace: true });
  };
  const openModal = () => {
    setIsOpen(true);
  };
  const toScanPage = (studentId: string, grade: string) => {
    navigate(`/pickup-student/scan/${studentId}/${grade}`);
  };
  const toQRPage = (studentId: string, grade: string, studentName: string) => {
    navigate(`/pickup-student/create-qr/${studentId}/${grade}/${studentName}`);
  };
  const toBookingPage = () => {
    navigate(`/pickup-student/booking`);
  };
  const toStatusBookingPage = () => {
    navigate("/pickup-student/status");
  };

  useEffect(() => {
    console.log(location.pathname.split("/")[2]);

    if (location.pathname.split("/")[2] != undefined) {
      if (location.pathname.split("/")[2] != "token") {
        setIsToken(true);
        dispatch(setToken(location.pathname.split("/")[2]));
        getData();
      }

      if (location.pathname.split("/")[3] != undefined) {
        var lang = location.pathname.split("/")[3];
        i18n.changeLanguage(lang);
        dispatch(setLanguage(lang));
      }
    }
  }, [location.pathname.split("/")[2]]);

  function getData() {
    API.credentialCheck().then((resCredential) => {
      dispatch(setUser(resCredential.data.user));
      const identities = resCredential.data.user.accounts[0].callerIdentities;
      setCallerIdentity(identities);
      if (identities.length === 1) {
        setCaller((prevCaller: string) => prevCaller || identities[0].callerId);
      }
      // getData();
    });
  }

  const getComboStudent = async () => {
    try {
      let query = [];
      query.push(`student_class=`);
      dispatch(setLoading(true));
      let response = await comboStudentsClassViolation(query);
      setStudents(response.data);
      const selectStudent = response.data[0];
      localStorage.setItem("selectStudent", JSON.stringify(selectStudent));
      setStudentSelected(selectStudent);
      getDashboard(selectStudent.id);
    } catch (error) {
    } finally {
      dispatch(setLoading(false));
    }
  };

  const getDashboard = async (studentId: string) => {
    try {
      let query = [];
      query.push(`student_id=${studentId}`);
      dispatch(setLoading(true));
      let response = await violationPointDashboard(query);
      console.log(response);
      setData(response.data);
    } catch (error) {
      console.log(error);
    } finally {
      dispatch(setLoading(false));
    }
  };

  const changeStudent = (value: any) => {
    setStudentSelected(value);
    getDashboard(value._id);
    localStorage.setItem("selectStudent", JSON.stringify(value));
    setIsOpen(false);
  };

  const getProfileImage = (photo: string) => {
    if (photo == "") return users;
    return env + "main_base/image/get/" + photo + "/pas";
  };
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
      title: "Point Pelanggaran",
    });
    getComboStudent();
    if (isBrowser) {
    }
  }, []);
  return (
    <>
      <BrowserView>
        <Transition appear show={isOpen} as={Fragment}>
          <Dialog as="div" className="relative z-10" onClose={closeModal}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-black bg-opacity-25" />
            </Transition.Child>

            <div className="fixed inset-0 overflow-y-auto">
              <div className="flex min-h-full items-center justify-center p-4 text-center">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 scale-95"
                  enterTo="opacity-100 scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 scale-100"
                  leaveTo="opacity-0 scale-95"
                >
                  <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-psp-primary p-6 text-left align-middle shadow-xl transition-all">
                    <Dialog.Title
                      as="h3"
                      className="text-lg font-medium leading-6 text-gray-900"
                    >
                      <div className="flex flex-row">
                        {/* <img
                          src={helpIcon}
                          alt=""
                          className="text-black mr-2"
                        /> */}
                        {/* <div>{t("DIGITALCARD.help")}</div> */}
                      </div>
                    </Dialog.Title>
                    <div className="rounded-2xl bg-psp-primary mt-3 p-2">
                      Mohon maaf, Fitur ini belum tersedia pada perangkat
                      desktop
                    </div>
                    <div>
                      <button
                        type="button"
                        className="w-full h-10 ml-1 rounded-md text-white bg-psp-btn-primary"
                        onClick={closeModal}
                      >
                        {t("OTHER.back")}
                      </button>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition>
        <ViolationPointWeb
          key={`${JSON.stringify(data)}-${JSON.stringify(students)}-${JSON.stringify(studentSelected)}`}
          getProfileImage={(e: string) => getProfileImage(e)}
          changeStudent={(e: any) => changeStudent(e)}
          getComboStudent={getComboStudent}
          studentSelect={studentSelected}
          studentList={students}
          dataPoint={data}
          getDashboard={(id: string) => getDashboard(id)}
        ></ViolationPointWeb>
      </BrowserView>
      <MobileView>
        <ViolationPointMobile
          key={`${JSON.stringify(data).length}-${JSON.stringify(students).length}-${JSON.stringify(studentSelected).length}-${isOpen ? "open" : "close"}`}
          getProfileImage={(e: string) => getProfileImage(e)}
          isOpen={isOpen}
          setIsOpen={(e: boolean) => setIsOpen(e)}
          changeStudent={(e: any) => changeStudent(e)}
          getComboStudent={getComboStudent}
          studentSelect={studentSelected}
          studentList={students}
          dataPoint={data}
          getDashboard={(id: string) => getDashboard(id)}
        ></ViolationPointMobile>
      </MobileView>
    </>
  );
};

export default ViolationPointComponent;
